<form [formGroup]="form" (ngSubmit)="addProtocol()">
    <div class="card-content">
        <div>
            <div class="full-width">
                <div class="card-inline">
                    <mat-form-field class="medium-width margin-right-small">
                        <input type="text" #newProtocol matInput placeholder="Protocolo" formControlName="NewProtocol">
                    </mat-form-field>
                    <button *ngIf="!loading" type="submit" mat-icon-button mat-mini-fab>
                <mat-icon>add</mat-icon>
              </button>
                </div>
                <mat-divider *ngIf="studyReportBatchItemsForm.controls.length > 0"></mat-divider>
                <mat-spinner *ngIf="loading"></mat-spinner>
                <div style="max-height:500px;overflow-y:auto">
                  <table mat-table class="search-table margin-botton-medium" *ngIf="!loading && studyReportBatchItemsForm.controls.length > 0" [dataSource]="dataSource" formArrayName="StudyReportBatchItems">
                    <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayColumns"></tr>
                    <tr mat-row class="search-table-cell" *matRowDef="let row; let i = index; columns: displayColumns;"></tr>

                    <ng-container matColumnDef="Protocol">
                      <th mat-header-cell class="table-header" *matHeaderCellDef> Protocolo </th>
                      <td class="search-table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                        {{displayProtocol(index)}}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="PracticeRegionName">
                      <th mat-header-cell class="table-header" *matHeaderCellDef> Práctica </th>
                      <td class="search-table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                        {{displayPracticeRegionName(index)}}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="PatientFullName">
                      <th mat-header-cell class="table-header" *matHeaderCellDef> Paciente </th>
                      <td class="search-table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                        {{displayPatientFullName(index)}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="PreviousStudies">
                      <th mat-header-cell class="table-header" *matHeaderCellDef> Estudios ant. </th>
                      <td class="search-table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                        {{displayPreviousStudies(index)}}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="PreviousStudiesAmount">
                      <th mat-header-cell class="table-header" *matHeaderCellDef>Cant. estudios ant.</th>
                      <td class="search-table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                        {{displayPreviousStudiesAmount(index)}}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="PreviousStudiesDetails">
                      <th mat-header-cell class="table-header" *matHeaderCellDef>Det. estudios ant </th>
                      <td class="search-table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                        {{displayPreviousStudiesDetails(index)}}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="RegionName">
                      <th mat-header-cell class="table-header" *matHeaderCellDef>Región </th>
                      <td class="search-table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                        {{displayRegionName(index)}}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="buttons" stickyEnd>
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index" (click)="$event.stopPropagation()">
                        <mat-icon class="cursor-default" (click)="deleteProtocol(index)">delete</mat-icon>
                      </td>
                    </ng-container>
                  </table>
                </div>
            </div>
        </div>
    </div>
</form>
